import monomoEyeIcon from '@/assets/auth/monomo-eye.svg';

type AuthPasswordToggleProps = {
  showPassword: boolean;
  onToggle: () => void;
};

export function AuthPasswordToggle({ showPassword, onToggle }: AuthPasswordToggleProps) {
  return (
    <button
      type="button"
      className="absolute right-3 top-1/2 size-6 -translate-y-1/2 overflow-hidden"
      onClick={onToggle}
      aria-label={showPassword ? 'Skrýt heslo' : 'Zobrazit heslo'}
    >
      <img src={monomoEyeIcon} alt="" className="size-full" />
    </button>
  );
}
